import { styled } from "sharedUI/styles";
import { BaseScreenStyle } from "../../../ui/views/base-screen/base-screen-style";

export const AcceptInviteScreenStyle = styled(BaseScreenStyle)`
    display: flex;

    justify-content: center;
    align-items: center;

    flex-direction: column;

    background-color: ${p => p.theme.bgColorAlt};

    .aiss-main-area {
        position: relative;

        width: 600px;
        height: 342px;
        padding: 50px;
        color: ${p => p.theme.fgColorDark};
        font-size: 24px;
        border-radius: 12px;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: ${p => p.theme.bgColorLight};
        border: 1px solid ${p => p.theme.borderColor};

        text-align: center;

        span {
            font-weight: 500;
        }

        .aiss-error {
            color: ${p => p.theme.destroyColor};
            font-size: 12px;
            font-weight: normal;
            text-align: center;

            position: absolute;
            left: 0;
            right: 0;
            bottom: 40px;
        }

        button {
            margin-top: 55px;
            background-color: ${p => p.theme.acceptColor};
            border-radius: 6px;

            font-size: 20px;
            height: 45px;
            padding: 8px 20px;

            color: white;

            cursor: pointer;

            display: flex;
            justify-content: center;
            align-items: center;
            > :first-child {
                margin-right: 8px;
            }

            :disabled {
                opacity: 0.4;
            }
        }
    }
`;
